/* unplugin-vue-components disabled */import script from "./otherTail.vue?vue&type=script&setup=true&lang=js"
export * from "./otherTail.vue?vue&type=script&setup=true&lang=js"

import "./otherTail.vue?vue&type=style&index=0&id=1ff1fc38&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff1fc38"]])

export default __exports__